import templateUrl from "emun.invoice/inv/inv-summary-actions.htm";
export default () => ({ templateUrl });
